import { Component, HostListener, input, output } from '@angular/core';
import { IntegracaoExecucaoStatus } from '../../core/enum/integracao-execucao-status.enum';
import { IntegracaoLog } from '../../core/models/integracao.model';

/** O enum carrega o valor da API; a tela mostra o rótulo legível. */
const ROTULO_STATUS: Record<IntegracaoExecucaoStatus, string> = {
  [IntegracaoExecucaoStatus.EmAndamento]: 'Em andamento',
  [IntegracaoExecucaoStatus.Concluido]: 'Concluído',
  [IntegracaoExecucaoStatus.Erro]: 'Erro',
};

@Component({
  selector: 'app-integracao-log-dialog',
  templateUrl: './integracao-log-dialog.component.html',
  styleUrl: './integracao-log-dialog.component.scss',
})
export class IntegracaoLogDialogComponent {
  readonly log = input.required<IntegracaoLog>();

  readonly fechar = output<void>();

  rotuloStatus(status: IntegracaoExecucaoStatus): string {
    return ROTULO_STATUS[status];
  }

  onFechar(): void {
    this.fechar.emit();
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.onFechar();
  }
}
